import { connect } from 'react-redux';
import fetchPermissions from '../../../../redux/actions/roles&permissions/permissions';
import Permissions from './Permissions';

const mapStateToProps = (state) => ({
  permissions: state.permissions,
});
const mapDispatchToProps = (dispatch) => ({
  fetchPermissions: () => dispatch(fetchPermissions()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Permissions);
